export const delegateCard = {
  state: { expandedCardId: 'delegateProfileFormContainer' },
  reducers: {
    expandCard: (state, payload) => ({
      ...state,
      expandedCardId: payload,
    }),
  },
};
